import { useEffect, useRef, useState } from "react";

type Props = {
  name: string
  value: boolean
  disabled?: boolean
  onChange?: (value: boolean) => void
}

const FormSwitch = ({name, value, disabled, onChange: onChangeFunc} : Props)  => {
  
  const checkboxRef = useRef<HTMLInputElement>(null);
  const [yesno, setYesNo] = useState('NO');
  
  useEffect(() => {
    if (! (checkboxRef.current && checkboxRef.current.checked !== value)) {
      return;
    }
    checkboxRef.current.checked = value;
    setYesNo(value ? 'YES' : 'NO');
  // eslint-disable-next-line 
  }, []);

  return (
  
  <div className='form-check form-switch form-switch-sm form-check-custom form-check-solid'>
    <input      
      name={name}
      ref={checkboxRef}
      className='form-check-input'
      type='checkbox'
      onChange={() => {
        const _flagval = checkboxRef.current && checkboxRef.current.checked ? true : false;       
        setYesNo(_flagval ? 'YES' : 'NO'); 
        if (onChangeFunc) {
          onChangeFunc(_flagval)
        }
      }}
      disabled={disabled}
    />
    <label className='form-check-label'>{`${yesno}`}</label>
  </div>

  )
}

export { FormSwitch }